import { FormControl, Validators } from '@angular/forms';

export function nullableEmailValidator(
  control: FormControl
): { [key: string]: any } {
  if (control.value) {
    const result = Validators.email(control);
    return result;
  }
}



// WEBPACK FOOTER //
// E:/proj/news12/zb-n12/scadmin/client/src/app/shared/validators/nullableEmailValidator.ts